<template>
  <div>
    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="panel panel-default">
        <div class="panel-body">
          <table class="table table-condensed table-striped">
            <thead>
            <tr>
              <th class="col-xs-1 text-center">
                <input type="checkbox" v-model="selectAll">
              </th>

              <th class="col-xs-6">
                Title
              </th>

              <th class="col-xs-3">
                User
              </th>

              <th class="col-xs-3">
                Portal
              </th>

              <th class="col-xs-2">
                Value
              </th>

              <th class="col-xs-3">
                Expected At
              </th>

              <th class="col-xs-5">
                Attributes
              </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="opportunity in opportunities.data">
              <td class="text-center">
                <input type="checkbox" v-model="selected" :value="opportunity">
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/companies/' + opportunity.attributes.company_id + '/opportunities/' + opportunity.id">
                  {{ opportunity.attributes.title }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/users/' + opportunity.attributes.user_id + '/edit'">
                  {{ opportunity.attributes.user_full_name }}
                </router-link>
              </td>

              <td class="table__ellipsis">
                <router-link :to="'/portals/' + opportunity.attributes.portal_id">
                  {{ opportunity.attributes.portal_name }}
                </router-link>
              </td>

              <td>
                {{ opportunity.attributes.value | price }}
              </td>

              <td>
                {{ opportunity.attributes.conversion_expected_at | date }}
              </td>

              <td>
                <span v-if="opportunity.attributes.category === 'advertising'" class="label label-info">Advertising</span>

                <span v-if="opportunity.attributes.category === 'subscription'" class="label label-default">Subscription</span>

                <span v-if="opportunity.attributes.is_new_business === true" class="label label-success">New</span>

                <span v-if="opportunity.attributes.is_new_business === false" class="label label-warning">Existing</span>

                <span v-if="opportunity.attributes.is_new_business === null" class="label label-info">Unknown</span>

                <span v-if="opportunity.attributes.status === 'converted'" class="label label-success">Converted</span>

                <span v-if="opportunity.attributes.status === 'open'" class="label label-warning">Open</span>

                <span v-if="opportunity.attributes.status === 'missed'" class="label label-danger">Missed</span>
              </td>

              <td class="text-right">
                <div class="btn-group list-actions">
                  <router-link
                      :to="'/companies/' + opportunity.attributes.company_id + '/opportunities/' + opportunity.id"
                      class="btn btn-sm">
                    <i class="fa fa-search"></i>
                  </router-link>

                  <button type="button" class="btn btn-sm" @click="destroy(opportunity)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>

            <tr v-if="!opportunities.data.length">
              <td colspan="8" class="text-center">
                <i>
                  There are no opportunities to display.
                </i>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-xs-6">
              <div class="dropdown" v-if="selected.length">
                <button
                    class="btn btn-info btn-sm dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                >
                  <i class="fa fa-cogs"></i> List Actions <span class="caret"></span>
                </button>

                <ul class="dropdown-menu">
                  <li>
                    <a href="#" @click.prevent="destroySelected">
                      <i class="fa fa-trash"></i> Delete
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div class="col-xs-12">
              <pager :pagination="opportunities.meta" @navigate="navigate"></pager>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import Load from '@/mixins/Load'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import OpportunityStatusLabel from '@/components/StatusLabels/OpportunityStatusLabel'
import Pager from '@/components/Lists/Pager'

export default {
  components: {LoadingContainer, OpportunityStatusLabel, Pager},

  mixins: [Load],

  model: {
    prop: 'owner',
    event: 'owner-updated'
  },

  props: ['owner'],

  data() {
    return {
      opportunities: {},
      page: this.getQueryParam('page', 1),
      selected: [],
      selectAll: false
    }
  },

  watch: {
    selectAll(value) {
      this.selected = value ? this.opportunities.data : []
    },

    '$route'() {
      this.load()
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    queryString() {
      return '?page=' + this.page
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/opportunities', {
        'filter[company_id]': this.owner.data.id,
        page: this.page,
        page_size: 25
      })
          .then(response => {
            this.opportunities = response.data

            this.loading = false
          })
    },

    destroy(opportunity) {
      modal.confirm('Are you sure that you want to delete the opportunity?', () => {
        this.getDestroyPromise(opportunity)
            .then(() => {
              notify.success('The opportunity was deleted')

              this.navigate(1)
            })
      })
    },

    destroySelected() {
      modal.confirm('Are you sure that you want to delete the opportunities?', () => {
        axios.all(this.selected.map(opportunity => this.getDestroyPromise(opportunity)))
            .then(() => {
              notify.success('The opportunities were deleted')

              this.navigate(1)
            })
      })
    },

    getDestroyPromise(opportunity) {
      return http.delete('/api/v2/opportunities/' + opportunity.id)
    },

    navigate(page) {
      this.resetSelections()

      this.page = page

      if (this.page === parseInt(this.$route.query.page)) {
        this.load()
      }

      this.$router.push('opportunities' + this.queryString)
    },

    resetSelections() {
      this.selected = []

      this.selectAll = false
    },

    getQueryParam(key, defaultValue = null) {
      return typeof this.$route.query[key] !== 'undefined' ? this.$route.query[key] : defaultValue
    }
  }
}
</script>
